// extracted by mini-css-extract-plugin
export default {"buttons":"Contact_buttons__3+0kp","warning":"Contact_warning__b29XQ","contact":"Contact_contact__aSPrY","footer":"Contact_footer__zb6Aq"};